import { ENV } from "../utils";

export class ContactoEmails {
  baseApi = ENV.BASE_API;

  async getAll(accessToken) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CORREO_DESTINATARIOS}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async create(accessToken, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CORREO_DESTINATARIOS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 201) throw data;
    return data;
  }

  async update(accessToken, id, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CORREO_DESTINATARIOS}/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async remove(accessToken, id) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CORREO_DESTINATARIOS}/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }
}
